import React, { useMemo } from 'react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { parsePlaylistIds } from '@jwp/ott-common/src/utils/collection';

import type { ScreenComponent } from '../../../../../types/screens';
import ShelfList from '../../../../containers/ShelfList/ShelfList';
import Hero from '../../../../components/Hero/Hero';
import HeroTitle from '../../../../components/Hero/HeroTitle';
import HeroDescription from '../../../../components/Hero/HeroDescription';

const MediaHub: ScreenComponent<PlaylistItem> = ({ data }) => {
  // Hub may specify multiple playlists as a CSV list of IDs or a single playlist
  const rows = useMemo(() => parsePlaylistIds(data.playlists || data.playlist), [data.playlist, data.playlists]);
  const hasHero = !!data.title && !!data.description;

  return (
    <>
      {hasHero && (
        <header>
          <Hero image={data.backgroundImage}>
            <HeroTitle title={data.title} />
            <HeroDescription description={data.description} />
          </Hero>
        </header>
      )}
      <ShelfList rows={rows} forceHeroShelf={!hasHero}></ShelfList>
    </>
  );
};

export default MediaHub;
